const steps = [
  {
    title: "お問い合わせ",
    text: "お電話（0120-02-4747）またはLINEでお気軽にご相談ください。",
  },
  {
    title: "現地調査・見積り",
    text: "現地を確認し、作業内容と概算のお見積りを無料で提示します。写真見積りも可能です。",
  },
  {
    title: "作業プラン確定",
    text: "作業内容と料金をご確認いただき、ご納得いただいてからご契約いただきます。",
  },
  {
    title: "作業日のご予約",
    text: "ご都合に合わせて、作業日を決定します。近隣に配慮した作業方法もご相談ください。",
  },
  {
    title: "清掃作業",
    text: "堆積ゴミの搬出・消臭・除菌・害虫駆除まで、プライバシーに配慮して対応します。",
  },
  {
    title: "完了確認・お引渡し",
    text: "作業後はお部屋の状態をご確認いただき、完了です。清掃後の写真もご報告します。",
  },
];

export default function Flow() {
  return (
    <section id="flow" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            FLOW
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            ゴミ屋敷清掃の<span className="text-primary-500">作業の流れ</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-bold text-sm shrink-0">
                  {i + 1}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-900">
                  {s.title}
                </h3>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}